export const MAX_DURATION_CYCLES = 5;
